import { AskHelpInput, AskHelpOutput } from '@allocab/allocab-passenger-shared-types';
// eslint-disable-next-line import/named
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const fetchHelp = (input: AskHelpInput) => passengerApi.get<AskHelpInput, AskHelpOutput>('/trip/v1/help', input);

const useFetchHelp = (options: UseMutationOptions<AskHelpOutput, APIError, AskHelpInput> = {}) => {
  const fetchHelpMutation = useMutation<AskHelpOutput, APIError, AskHelpInput>({
    mutationFn: fetchHelp,
    ...options,
  });

  return fetchHelpMutation;
};

export default useFetchHelp;
